import { ChangeDetectionStrategy, Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DsDialogService } from '@skyeng/libs/shared/ui-kit-v2/dialog';
import { AttachmentFullsizeDialogComponent } from '../attachment-fullsize-dialog/attachment-fullsize-dialog';
import { Store } from '@skyeng/libs/shared/store';
import { AttachmentFileType } from '../../interface';

@Component({
  selector: 'skypro-message-attachment-preview',
  templateUrl: 'attachment-preview.html',
  styleUrls: ['attachment-preview.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AttachmentPreviewComponent implements OnChanges {
  @Input() url: string;
  @Input() bigAttachmentPreview = false;
  @Input() type?: AttachmentFileType;
  @Input() title?: string;

  store = new Store({
    type: null as AttachmentFileType | null,
  });

  type$ = this.store.select('type');

  AttachmentFileType = AttachmentFileType;

  private dsDialogService = inject(DsDialogService);

  ngOnChanges(changes: SimpleChanges): void {
    if ('url' in changes || 'type' in changes) {
      this.store.updateFields({ type: this.type ?? this.getTypeByUrl(this.url) });
    }
  }

  openFullsizeMedia(): void {
    const type = this.type ?? this.getTypeByUrl(this.url);

    if ([AttachmentFileType.image, AttachmentFileType.video].includes(type)) {
      this.dsDialogService.open<{ url: string; type: string }, void>(AttachmentFullsizeDialogComponent, {
        url: this.url,
        type,
      });
      return;
    }

    window.open(this.url);
  }

  private getTypeByUrl(url: string): AttachmentFileType {
    const extension = this.getFileExtension(url);

    switch (extension) {
      case 'jpeg':
      case 'jpg':
      case 'png':
      case 'gif':
        return AttachmentFileType.image;
      case 'mp4':
      case 'mov':
      case 'wmv':
      case 'avi':
      case 'webm':
      case 'qt':
        return AttachmentFileType.video;
      default:
        return AttachmentFileType.other;
    }
  }

  private getFileExtension(url: string): string {
    const pieces = url.split('.');
    return pieces[pieces.length - 1].trim();
  }
}
